export default "__VITE_ASSET__0$fEfR$C__"